import { Price } from "~/components/price.component";
import type { PriceComparisonDiscount } from "~/features/price-comparison/price-comparison-discounts";

export function PriceComparisonOldPrice({
	priceComparisonDiscount,
	productCategory,
	productKind,
}: {
	priceComparisonDiscount?: PriceComparisonDiscount;
	productCategory: string | null;
	productKind?: string | null;
}) {
	if (!priceComparisonDiscount || !priceComparisonDiscount?.visible) {
		return null;
	}

	return (
		<Price
			className="line-through text-gray-700 text-body-sm"
			variant={"raw"}
			price={priceComparisonDiscount.nonDiscountedPrice}
			category={productCategory}
			kind={productKind}
		/>
	);
}
